export default {
    name: 'localhost',
    status: null,

    apiUrl: 'http://127.0.0.1:21025/api/',
    websocketUrl: 'http://127.0.0.1:21025/socket/',
    prefix: 'local',

    settings: {
        host: '127.0.0.1',
        port: '21025'
    }
};
